import { useAppSelector } from "store/rootReducer";

import { Permission } from "utils/entities/permission";

interface UserPermissions {
  create: boolean;
  edit: boolean;
  exclude: boolean;
  read: boolean;
  import?: boolean;
  export?: boolean;
  proceduresByPoliceStation?: boolean;
  proceduresPerPoliceUnit?: boolean;
  proceduresPerYear?: boolean;
  logOperation?: boolean;
  logErrors?: boolean;
  managerHearingClassified?: boolean;
  hashValidator?: boolean;
  notify?: boolean;
  loggedUsers?: boolean;
  record?: boolean;
  hearingCorrection?: boolean;
  hearingAttendantUnlink?: boolean;
  viewOnlyYourRecords?: boolean;
}

export function actionValid(action: string) {
  if (action === "ProceduresPerPoliceUnit") return "ProceduresByPoliceStation";
  return action;
}

export function returnPermissionsByFuncionality(
  form: string,
  permissions: Permission[],
): UserPermissions {
  if (permissions.length === 0)
    return {
      create: false,
      edit: false,
      exclude: false,
      read: false,
      export: false,
      proceduresByPoliceStation: false,
      proceduresPerPoliceUnit: false,
      proceduresPerYear: false,
      logOperation: false,
      logErrors: false,
      managerHearingClassified: false,
      hashValidator: false,
      notify: false,
      import: false,
      record: false,
      hearingCorrection: false,
      hearingAttendantUnlink: false,
    };

  const permissionsByForm = permissions?.filter((item) => item.name === form);
  if (permissionsByForm.length === 0) {
    return {
      create: false,
      edit: false,
      exclude: false,
      read: false,
      export: false,
      proceduresByPoliceStation: false,
      proceduresPerPoliceUnit: false,
      proceduresPerYear: false,
      logOperation: false,
      logErrors: false,
      managerHearingClassified: false,
      hashValidator: false,
      notify: false,
      import: false,
      record: false,
      hearingCorrection: false,
      hearingAttendantUnlink: false,
      viewOnlyYourRecords: false,
    };
  }

  const permission =
    permissionsByForm[0].listObjectUserProfileActionDTOs.reduce(
      (a: any, b: any) => {
        a.push(b.action);
        return a;
      },
      [],
    );

  return {
    create: permission.includes("Insert"),
    edit: permission.includes("Update"),
    exclude: permission.includes("Delete"),
    read: permission.includes("Read"),
    export: permission.includes("Export"),
    notify: permission.includes("Notify"),
    import: permission.includes("Import"),
    record: permission.includes("Recording"),
    proceduresByPoliceStation: permission.includes("ProceduresByPoliceStation"),
    proceduresPerPoliceUnit: permission.includes("ProceduresPerPoliceUnit"),
    proceduresPerYear: permission.includes("ProceduresPerYear"),
    logOperation: permission.includes("LogOperation"),
    logErrors: permission.includes("LogError"),
    managerHearingClassified: permission.includes("ManagerHearingClassified"),
    hashValidator: permission.includes("HashValidator"),
    loggedUsers: permission.includes("LoggedUsers"),
    hearingCorrection: permission.includes("HearingCorrection"),
    hearingAttendantUnlink: permission.includes("HearingAttendantUnlink"),
    viewOnlyYourRecords: permission.includes("ViewOnlyYourRecords"),
  };
}

export function returnReportPermisison({ name, permissions }: any) {
  let reportPermission = {
    read: false,
  };

  permissions?.forEach((element: any) => {
    if (element.name === "Report") {
      element.listObjectUserProfileActionDTOs?.forEach((report: any) => {
        if (actionValid(report.action) === name)
          reportPermission = {
            read: actionValid(report.action) === name,
          };
      });
    }
  });

  return reportPermission;
}

export function usePermissions(form: string): UserPermissions {
  const { permissions } = useAppSelector((state) => state.permissions);

  const userPermissions = returnPermissionsByFuncionality(form, permissions!);
  return userPermissions;
}

// export function getPermissions2 (form: string, permissions: Permission[]) {

//   //const permissions = useSelector((state: any) => state.permissions);
//   return returnPermissionsByFuncionality(form, permissions)
// }
